    import React, { useState , useEffect } from 'react'
    import { Link, useNavigate, useParams } from 'react-router-dom'
    import avtar5 from '../../assets/images/user/avatar-5.jpg'
    import { toast } from 'react-toastify'
    import { getData, putData } from '../Services/api'

    const UpdateAccounts = () => {
        const { id } = useParams();
        const [values, setValues] = useState({
            username: "",
            email: "",
            mobile: "",
            password: "",
            role: "accounts",
            profile_image: null,
        })
        const [loading, setLoading] = useState(false)
        const [poTypes, setPoTypes] = useState([]);
        const [selectedPoTypes, setSelectedPoTypes] = useState([]);
        const navigate = useNavigate();

        const fetchPoTypes = async () => {
            try {
                const res = await getData('/po-types?all=true');
                if (res.status) {
                    setPoTypes(res.data || []);
                }
            } catch (error) {
                console.log("error fetch po types", error);
            }
        };

        const fetchRoutes = async () => {
            try {
            await getData('/routes/all');
            } catch (error) {
            console.log("error fetch routes", error)
            }
        }

        // fetch all managers
        const fetchManagers = async () => {
            try {
                await getData('/users/getAllManager-admin')
            } catch (error) {
                console.error("Error fetching managers", error)
                toast.error("Failed to load managers")
            }
        }

        const fetchUserDetails = async () => {
            try {
                const res = await getData(`/users/details/${id}`);
                if (res.status) {
                    setValues(res.data || {})
                    if (res.data && Array.isArray(res.data.poTypes)) {
                        setSelectedPoTypes(res.data.poTypes.map(pt => pt.id));
                    }
                }
            } catch (error) {
                console.log("error fetch user details", error)
            }
        }

        useEffect(() => {
            fetchUserDetails()
            fetchManagers()
            fetchRoutes()
            fetchPoTypes()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [id])




        const handleChange = (e) => {
            const { name, value } = e.target;
            setValues({ ...values, [name]: value });
        }

        const handleImageChange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setValues(prev => ({
                    ...prev,
                    profile_image: file,
                }));
            }
        };

        const validateUser = () => {
            const { username, email, mobile, role, password } = values;
            toast.dismiss();
            if (!username.trim()) {
                toast.error("Username is required.");
                return false;
            }
            if (!email.trim()) {
                toast.error("Email is required.");
                return false;
            }
            if (!/\S+@\S+\.\S+/.test(email)) {
                toast.error("Invalid email format.");
                return false;
            }
            if (!mobile.trim()) {
                toast.error("Mobile No. is required.");
                return false;
            }
            // if (!/^\d{9}$/.test(mobile)) {
            //             toast.error("Mobile number must be exactly 9 digits.");
            //             return false;
            //         }
            if (!role.trim()) {
                toast.error("Role is required.");
                return false;
            }
            if (password && password.trim() !== '') {
                if (password.length < 6) {
                    toast.error("Password must be at least 6 characters.");
                    return false;
                }
            }
            return true;
        }

        const handleSubmit = async (e) => {
            e.preventDefault();
            if (!validateUser()) return;
            setLoading(true)
            try {
                const formData = new FormData();
                formData.append('username', values.username);
                formData.append('email', values.email);
                formData.append('mobile', values.mobile);
                formData.append('role', values.role);
                formData.append('po_type_ids', JSON.stringify(selectedPoTypes));
                if (values.password && values.password.trim() !== '') {
                    formData.append('password', values.password);
                }
                if (values.profile_image) {
                    formData.append('profile_image', values.profile_image);
                }

                const res = await putData(`/users/update/${id}`, formData);
                if (res.status) {
                    toast.success(res.message)
                    navigate('/accounts/accounts-list');
                    setValues({
                        username: "",
                        email: "",
                        mobile: "",
                        password: "",
                        role: "",
                        profile_image: null,
                    })
                } else {
                    toast.error(res.message)
                }
            } catch (error) {
                console.log("error user adding", error)
                toast.error(error.response.data.message || 'error')
            } finally {
                setLoading(false)
            }
        }
        return (
            <>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="page-header">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/">
                                                    Home</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to="/accounts/accounts-list"> Accounts Users</Link>
                                            </li>
                                            <li className="breadcrumb-item" aria-current="page">
                                                 Edit Accounts User
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="page-header-title">
                                            <h2 className="mb-0">Edit Accounts User</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Add Accounts User</h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-sm-12 text-center mb-3">
                                                    <div className="user-upload wid-75">
                                                        <img
                                                            src={values.profile_image ? URL.createObjectURL(values.profile_image) : avtar5}
                                                            alt="img"
                                                            className="img-fluid"
                                                        />
                                                        <label htmlFor="uplfile" className="img-avtar-upload">
                                                            <i className="fa fa-camera f-24 mb-1" />
                                                            <span>Upload</span>
                                                        </label>
                                                        <input type="file" id="uplfile" className="d-none"
                                                            onChange={handleImageChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter username"
                                                            name='username'
                                                            value={values.username}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Contact Number</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter Contact number"
                                                            name='mobile'
                                                            value={values.mobile}
                                                            onChange={handleChange}
                                                        />
                                                    </div>


                                                    {/* <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label">Select Route</label>
                                                            <select
                                                                className="form-select"
                                                                name="route_id"
                                                                value={values.route_id}
                                                                onChange={(e) => {
                                                                    const options = Array.from(e.target.selectedOptions, option => option.value);
                                                                    setValues(prev => ({ ...prev, route_id: options }));
                                                                }}
                                                                multiple
                                                                >
                                                            <option value="">-- Select Route --</option>
                                                            {route.map(r => (
                                                                <option key={r.id} value={r.id}>
                                                                {r.route_name}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        </div>
                                                    </div> */}

                                                    
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Email</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Email"
                                                            name='email'
                                                            value={values.email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                     <div className="form-group">
                                                         <label className="form-label">Password</label>
                                                         <input
                                                             type="password"
                                                             className="form-control"
                                                             placeholder="***********"
                                                             name='password'
                                                             value={values.password}
                                                             onChange={handleChange}
                                                         />
                                                     </div>

                                                     {poTypes.length > 0 && (
                                                         <div className="col-md-12">
                                                             <div className="form-group">
                                                                 <label className="form-label">Allocated PO Types (Accounts View & Process Access)</label>
                                                                 <div className="d-flex flex-wrap gap-2 pt-1">
                                                                     {poTypes.map(pt => {
                                                                         const isChecked = selectedPoTypes.includes(pt.id);
                                                                         return (
                                                                             <label
                                                                                 key={pt.id}
                                                                                 className={`btn btn-sm ${isChecked ? 'btn-primary' : 'btn-outline-secondary'} d-flex align-items-center gap-1`}
                                                                                 style={{ cursor: 'pointer' }}
                                                                             >
                                                                                 <input
                                                                                     type="checkbox"
                                                                                     className="form-check-input me-1 d-none"
                                                                                     checked={isChecked}
                                                                                     onChange={() => {
                                                                                         if (isChecked) {
                                                                                             setSelectedPoTypes(selectedPoTypes.filter(id => id !== pt.id));
                                                                                         } else {
                                                                                             setSelectedPoTypes([...selectedPoTypes, pt.id]);
                                                                                         }
                                                                                     }}
                                                                                 />
                                                                                 <i className={`fas ${isChecked ? 'fa-check-square' : 'fa-square'}`}></i>
                                                                                 <span>{pt.type_name}</span>
                                                                             </label>
                                                                         );
                                                                     })}
                                                                 </div>
                                                             </div>
                                                         </div>
                                                     )}





                                                    {/* <div className="form-group">
                                                        <label className="form-label">Role</label>
                                                        <select className='form-select' name='role' value={values.role} onChange={handleChange}>
                                                            <option value="salesperson">Salesperson</option>
                                                            <option value="manager">Manager</option>
                                                        </select>
                                                    </div> */}

                                                </div>
                                                <div className="text-end btn-page mb-0 mt-4">
                                                    <Link to='/accounts/accounts-list' className="btn btn-outline-secondary">Cancel</Link>
                                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                                        {loading ? 'Saving...' : 'Save'}
                                                    </button>
                                                </div>
                                            </div>
                                        </form >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    export default UpdateAccounts